import React from 'react';
import { Link } from 'react-router-dom';

export default function SubscriptionCancelled() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6 text-center">
      <div className="w-full max-w-lg rounded-xl bg-white p-8 shadow-xl">
        <h1 className="text-3xl font-bold text-slate-800">Subscription checkout cancelled</h1>
        <p className="mt-4 text-slate-600">No subscription was created. You can review plans and try again whenever you are ready.</p>
        <Link to="/dashboard/billing" className="mt-8 inline-block rounded-lg bg-indigo-600 px-6 py-3 font-semibold text-white hover:bg-indigo-700">Return to Billing</Link>
      </div>
    </div>
  );
}
